module.exports = __webpack_public_path__ + "img/task-11-l.7966496b.png";